export const isDev = import.meta.env.MODE === "development";
export const isStandalone = isDev || import.meta.env.VITE_FRONT_APP_STANDALONE;
export const mode = import.meta.env.MODE;
